import { HastNode, isAllowedAnswerUrl } from './answerUrl';

// An image in a bot answer is fetched as soon as the answer renders, and CSP allows any https
// image, so an injected one could send chat data to any host without a click (#2561). Images are
// only shown from the hosts restyle links may point at.

// Markdown and raw-HTML images alike; an image from another host is replaced by its alt text.
const restrictImageHosts = (node: HastNode): void => {
    if (!node.children) {
        return;
    }
    node.children = node.children.flatMap((child): HastNode[] => {
        const src = child.properties?.src;
        if (child.tagName !== 'img' || (typeof src === 'string' && isAllowedAnswerUrl(src, window.location.href))) {
            restrictImageHosts(child);
            return [child];
        }
        const alt = child.properties?.alt;
        return typeof alt === 'string' && alt ? [{ type: 'text', value: alt }] : [];
    });
};

/** Rehype plugin for every view that renders bot answers, since each one loads their images. */
export const rehypeRestrictImageHosts = () => restrictImageHosts;
